var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagmanage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "#B5B8C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 0.259766H0.703688C0.314461 0.259766 0 0.574226 0 0.963454V4.48189H19.7033V0.963454C19.7033 0.574226 19.3888 0.259766 18.9996 0.259766ZM0 15.0372C0 15.4264 0.314461 15.7409 0.703688 15.7409H18.9996C19.3888 15.7409 19.7033 15.4264 19.7033 15.0372V6.41704H0V15.0372ZM12.7324 10.991C12.7324 10.8943 12.8115 10.8151 12.9083 10.8151H16.5367C16.6334 10.8151 16.7126 10.8943 16.7126 10.991V12.5743C16.7126 12.6711 16.6334 12.7502 16.5367 12.7502H12.9083C12.8115 12.7502 12.7324 12.6711 12.7324 12.5743V10.991Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagmanage);
export default __webpack_public_path__ + "static/media/tagmanage.a29d96ef68da54f0d50338c5843ee0a3.svg";
export { ForwardRef as ReactComponent };